import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"
import _imports_0 from '../assets/Logo--Ubiant-White.png'


const _hoisted_1 = { class: "flex flex-wrap p-3 min-h-screen" }
const _hoisted_2 = { class: "md:flex-order-1 col-12 md:col-6 flex justify-content-center align-items-center" }
const _hoisted_3 = { class: "grid lg:col-8 md:p-5 sm:p-2 justify-content-center" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "connect" }
const _hoisted_6 = { class: "md:flex-order-0 col-12 md:col-6 left-side" }
const _hoisted_7 = { class: "grid p-6 gap-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo-ubiant"
  })
], -1)
const _hoisted_9 = { class: "col-12 card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_CarousselCard = _resolveComponent("CarousselCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('app-name')), 1)
        ]),
        _createVNode(_component_router_view)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_TransitionGroup, { name: "slide" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards, (index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "grid"
                }, [
                  (index.id == _ctx.active)
                    ? (_openBlock(), _createBlock(_component_CarousselCard, {
                        key: 0,
                        imageName: index.imageName,
                        title: index.title,
                        text: index.text
                      }, null, 8, ["imageName", "title", "text"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}